var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloodlight01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.19,11.62c-1.97,0-3.58-1.6-3.58-3.58s1.61-3.58,3.58-3.58s3.58,1.61,3.58,3.58S8.16,11.62,6.19,11.62z  M6.19,4.97c-1.7,0-3.08,1.38-3.08,3.08c0,1.7,1.38,3.08,3.08,3.08c1.7,0,3.08-1.38,3.08-3.08C9.27,6.35,7.89,4.97,6.19,4.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.32,13.19c-2.79,0-5.1-2.23-5.17-5.04c0.12-3,2.55-5.33,5.53-5.33c0,0,0,0,0.01,0v0.5c0,0,0,0-0.01,0 c-2.71,0-4.92,2.12-5.03,4.83c0.07,2.56,2.24,4.6,4.8,4.53c0.07,0,0.14-0.01,0.22-0.01l0.03,0.5c-0.08,0.01-0.16,0.01-0.24,0.01 C6.41,13.18,6.36,13.19,6.32,13.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.98,
    y: 5.28,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -3.844 6.7524)",
    className: "st2",
    width: 0.5,
    height: 5.47
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 7.77,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.8442 6.7537)",
    className: "st2",
    width: 5.47,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "9.47,5.04 9.12,4.69 10.98,2.8 10.3,2.81 10.29,2.31 12.19,2.28  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "12.02,3.95 11.52,3.93 11.58,2.37 12.08,2.39  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "12.09,14.06 9.34,11.35 9.69,11 11.58,12.85 11.58,12.18 12.08,12.17  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "11.99,13.97 10.43,13.9 10.45,13.4 12.01,13.47  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloodlight01);
export default __webpack_public_path__ + "static/media/Floodlight-01.260b6f82b3448078d11bab358f889710.svg";
export { ForwardRef as ReactComponent };